// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 1024px)";
var _4 = "list_reset-_3VQx";
var _5 = "seat-fXydX";
var _6 = "seat_small-2L7zV";
var _7 = "seat_unavailable-1yHse";
var _8 = "seat_unexistent-3bBo4";
var _9 = "seat_collapsed-RtcA7";
var _a = "seat_recommend-3bZpY";
var _b = "seat_recommendCurrent-2iaaK";
var _c = "seat_free-2dLyU";
var _d = "seat_business-t4gS0";
var _e = "seat_preferred-2MIkT";
var _f = "seat_occupied-FjVc3";
var _10 = "seat_customColor-lY8MB";
var _11 = "span-uJWT7";
var _12 = "ripple-D4LIy";
var _13 = "number-3k3RS";
var _14 = "extendedIcon-gKrvT";
var _15 = "seatPrice-18M9v";
var _16 = "seat_withZeroPrice-FcJnu";
var _17 = "number_name-3X_QH";
var _18 = "seat_combinedLeft-3r8-p";
var _19 = "seat_combinedRight-1XT1D";
var _1a = "deselectIcon-2vXoC";
var _1b = "seat_confirmed-3vzbS";
var _1c = "withoutWindow-3OYS4";
var _1d = "withoutWindow_left-1bM4G";
var _1e = "withoutWindow_right-W7M9S";
var _1f = "male-1yvF0";
var _20 = "female-3TSza";
var _21 = "seat_aisle-Xuui0";
var _22 = "seat_extended-1eCxn";
var _23 = "seat_unrecline-1Kg_t";
var _24 = "seat_withPrice-1vdUD";
var _25 = "seat_standart-2Xwfj";
export { _1 as "__esModule", _2 as "mobile", _3 as "desktop_only", _4 as "list_reset", _5 as "seat", _6 as "seat_small", _7 as "seat_unavailable", _8 as "seat_unexistent", _9 as "seat_collapsed", _a as "seat_recommend", _b as "seat_recommendCurrent", _c as "seat_free", _d as "seat_business", _e as "seat_preferred", _f as "seat_occupied", _10 as "seat_customColor", _11 as "span", _12 as "ripple", _13 as "number", _14 as "extendedIcon", _15 as "seatPrice", _16 as "seat_withZeroPrice", _17 as "number_name", _18 as "seat_combinedLeft", _19 as "seat_combinedRight", _1a as "deselectIcon", _1b as "seat_confirmed", _1c as "withoutWindow", _1d as "withoutWindow_left", _1e as "withoutWindow_right", _1f as "male", _20 as "female", _21 as "seat_aisle", _22 as "seat_extended", _23 as "seat_unrecline", _24 as "seat_withPrice", _25 as "seat_standart" }
export default { "__esModule": _1, "mobile": _2, "desktop_only": _3, "list_reset": _4, "seat": _5, "seat_small": _6, "seat_unavailable": _7, "seat_unexistent": _8, "seat_collapsed": _9, "seat_recommend": _a, "seat_recommendCurrent": _b, "seat_free": _c, "seat_business": _d, "seat_preferred": _e, "seat_occupied": _f, "seat_customColor": _10, "span": _11, "ripple": _12, "number": _13, "extendedIcon": _14, "seatPrice": _15, "seat_withZeroPrice": _16, "number_name": _17, "seat_combinedLeft": _18, "seat_combinedRight": _19, "deselectIcon": _1a, "seat_confirmed": _1b, "withoutWindow": _1c, "withoutWindow_left": _1d, "withoutWindow_right": _1e, "male": _1f, "female": _20, "seat_aisle": _21, "seat_extended": _22, "seat_unrecline": _23, "seat_withPrice": _24, "seat_standart": _25 }
